interface CdtStudioContext {
  isPog: boolean;
  merchflowId?: number;
  hasCategoryIdentity: boolean;
  hasCategoryConfiguration: boolean;
  canEditCdt: boolean;
  /** A pegboard placement whose holes the Studio cannot read. */
  hasUnsupportedFixtures?: boolean;
}

export type CdtStudioUnavailableReason =
  | "notPlanogram"
  | "missingMerchflow"
  | "missingPermission"
  | "categoryUnavailable"
  | "configurationRequired"
  | "unsupportedFixtures";

export type CdtStudioAvailability =
  | { isAvailable: true }
  | { isAvailable: false; reason: CdtStudioUnavailableReason };

export const getCdtStudioAvailability = ({
  isPog,
  merchflowId,
  hasCategoryIdentity,
  hasCategoryConfiguration,
  canEditCdt,
  hasUnsupportedFixtures = false,
}: CdtStudioContext): CdtStudioAvailability => {
  if (!isPog) return { isAvailable: false, reason: "notPlanogram" };
  if (merchflowId === undefined) return { isAvailable: false, reason: "missingMerchflow" };
  if (!canEditCdt) return { isAvailable: false, reason: "missingPermission" };
  if (!hasCategoryIdentity) return { isAvailable: false, reason: "categoryUnavailable" };
  if (!hasCategoryConfiguration) {
    return { isAvailable: false, reason: "configurationRequired" };
  }
  if (hasUnsupportedFixtures) return { isAvailable: false, reason: "unsupportedFixtures" };
  return { isAvailable: true };
};

export const isCdtStudioEnabled = (context: CdtStudioContext): boolean =>
  getCdtStudioAvailability(context).isAvailable;
